module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-1.8679527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-1.png
// module id = aLm6
// module chunks = 34